/** M1.3 — Mutation Workspace UX (requires M1.1b + M1.2 backend). */
export function isMutationWorkspaceEnabled(): boolean {
  return process.env.REACT_APP_MUTATION_WORKSPACE === 'true';
}

export function isLiveTopologyMutationV2Client(): boolean {
  return process.env.REACT_APP_LIVE_TOPOLOGY_MUTATION_V2 === 'true';
}
